/*
==============================================================================
Código hecho por Rcrea
Archivo: assets/section-rcrea-guten-video-hero.js
Sección: Güten Brew | Hero Video Background
Función: video background + modal premium fuera del stacking del header
==============================================================================
*/

(() => {
  const sectionSelector = "[data-gb-video-hero]";
  const initializedAttribute = "data-gb-video-hero-initialized";

  const playVideo = (video) => {
    if (!video) return;

    video.playsInline = true;

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  };

  const initBackgroundVideos = (section) => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const videos = Array.from(section.querySelectorAll(".gb-video-hero__media video"));

    videos.forEach((video) => {
      video.muted = true;
      video.playsInline = true;

      if (prefersReducedMotion) {
        video.pause();
        return;
      }

      if (video.readyState >= 2) {
        playVideo(video);
      } else {
        video.addEventListener("loadeddata", () => playVideo(video), { once: true });
      }
    });
  };

  const moveModalToBody = (section, modal) => {
    if (!modal || modal.dataset.gbModalMoved === "true") return modal;

    const sectionId = section.getAttribute("id");

    if (sectionId) {
      modal.setAttribute("data-gb-modal-owner", sectionId);
    }

    document.body.appendChild(modal);
    modal.dataset.gbModalMoved = "true";

    return modal;
  };

  const openModal = (modal) => {
    if (!modal) return;

    const iframe = modal.querySelector("[data-gb-modal-iframe]");
    const video = modal.querySelector("video");

    modal.classList.add("is-active");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("gb-video-modal-open");
    document.body.classList.add("gb-video-modal-open");

    if (iframe) {
      const iframeSrc = iframe.getAttribute("data-src");

      if (iframeSrc) {
        iframe.setAttribute("src", iframeSrc);
      }
    }

    if (video) {
      video.currentTime = 0;
      video.muted = false;
      playVideo(video);
    }
  };

  const closeModal = (modal) => {
    if (!modal) return;

    const iframe = modal.querySelector("[data-gb-modal-iframe]");
    const video = modal.querySelector("video");

    modal.classList.remove("is-active");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("gb-video-modal-open");
    document.body.classList.remove("gb-video-modal-open");

    if (iframe) {
      iframe.setAttribute("src", "");
    }

    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  };

  const initVideoModal = (section) => {
    const trigger = section.querySelector("[data-gb-video-modal-trigger]");
    let modal = section.querySelector("[data-gb-video-modal]");

    if (!trigger || !modal) return;

    modal = moveModalToBody(section, modal);

    let holdTimer = null;
    let openedByHold = false;

    const hasModalMedia = () => {
      return Boolean(
        modal.querySelector("[data-gb-modal-iframe]") ||
        modal.querySelector("video")
      );
    };

    const clearHold = () => {
      window.clearTimeout(holdTimer);
      holdTimer = null;
      trigger.classList.remove("gb-video-hero__button--loading");
    };

    const startHold = () => {
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (prefersReducedMotion || !hasModalMedia()) return;

      openedByHold = false;
      clearHold();

      trigger.classList.add("gb-video-hero__button--loading");

      holdTimer = window.setTimeout(() => {
        openedByHold = true;
        clearHold();
        openModal(modal);
      }, 3000);
    };

    trigger.addEventListener("pointerenter", startHold);
    trigger.addEventListener("pointerleave", clearHold);
    trigger.addEventListener("focus", startHold);
    trigger.addEventListener("blur", clearHold);

    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      clearHold();

      openModal(modal);
    });

    modal.querySelectorAll("[data-gb-video-modal-close]").forEach((closeElement) => {
      closeElement.addEventListener("click", () => {
        closeModal(modal);
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && modal.classList.contains("is-active")) {
        closeModal(modal);
      }
    });
  };

  const initVideoHero = (section) => {
    if (!section || section.hasAttribute(initializedAttribute)) return;

    section.setAttribute(initializedAttribute, "true");

    initBackgroundVideos(section);
    initVideoModal(section);
  };

  const initAllVideoHeroes = (root = document) => {
    root.querySelectorAll(sectionSelector).forEach((section) => {
      initVideoHero(section);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllVideoHeroes());
  } else {
    initAllVideoHeroes();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAllVideoHeroes(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll("video").forEach((video) => {
      video.pause();
    });
  });
})();